import {Injectable, OnInit} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

import {environment} from '@environments/environment';
import {AccountService} from "../services";
import {UserType} from "@app/models";

@Injectable()
export class JwtInterceptor implements HttpInterceptor, OnInit {
  user: any

  constructor(private accountService: AccountService) {
    this.user = this.accountService.userValue
  }

  ngOnInit() {
    this.accountService.user.subscribe(user => {
      this.user = user
    })
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipIntercept = request.headers.has('skip');
    const orgManualIntercept = request.headers.has('org_manual');

    if (skipIntercept) {
      request = request.clone({
        headers: request.headers.delete('skip'),
      });
    }
    if (orgManualIntercept) {
      request = request.clone({
        headers: request.headers.delete('org_manual'),
      });
    }

    // add auth header with jwt if user is logged in and request is to the api url
    const user = this.accountService.userValue;
    const isLoggedIn = user && user.access;
    const intelligenceBase = (environment.api as any).intelligence;
    const isApiUrl = request.url.startsWith(environment.api.auth)
      || request.url.startsWith(environment.api.forms)
      || request.url.startsWith(environment.api.mercadeo)
      || request.url.startsWith(environment.api.moments)
      || request.url.startsWith(environment.api.sales)
      || (!!intelligenceBase && request.url.startsWith(intelligenceBase));
    if (isLoggedIn && isApiUrl) {

      let headers = request.headers.set('Authorization', `Bearer ${user?.access}`);
      if(!orgManualIntercept){
        if ((user?.user_type === UserType.DoItYourself && user?.connectedToOrg) ||
        (user?.user_type === UserType.Merchandising && user?.connectedToOrg)){

          if (!request.headers.has('x-org-id')) {
            headers = headers.set('x-org-id', `${user?.connectedToOrg.id}`);
          }
        }
        else{
          if (user?.organization && (
              request.url.startsWith(environment.api.auth)  // FE-ROL-06 (FM-ROL-12): backend-auth también necesita el tenant activo
              || request.url.startsWith(environment.api.mercadeo)
              || request.url.startsWith(environment.api.moments)
              || request.url.startsWith(environment.api.forms)
              || request.url.startsWith(environment.api.sales)
              || (!!intelligenceBase && request.url.startsWith(intelligenceBase))
            )) {

            if( !request.headers.has('x-org-id')) {
              headers = headers.set('x-org-id', `${user?.organization.id}`);
            }
          }
        }
      }

      request = request.clone({
        headers: headers
      });
    }

    return next.handle(request);
  }
}
